export const HOSTNAME = window?.location?.hostname ?? ''
export const DEV_HOSTNAMES = ['localhost', '127.0.0.1']
export const IS_DEV = import.meta.env.NODE_ENV === 'development' || DEV_HOSTNAMES.includes(HOSTNAME)
export const IS_TEST = import.meta.env.NODE_ENV === 'test'
export const GQL_SCHEMA_HASH = window.GQL_SCHEMA_HASH ?? 'unset'
export const APP_NAME: string = import.meta.env.APP_NAME
export const CI_COMMIT_SHA = window.CI_COMMIT_SHA ?? 'unset'
export const CI_RELEASE_TAG_NAME = window.CI_RELEASE_TAG_NAME ?? 'unset'
export const TAB_UUID = window.TAB_UUID ?? 'unset'
export const SENTRY_ENABLED = window.SENTRY_ENABLED ?? false
export const MEMBER_ID = window.MEMBER_ID ?? undefined
export const TEST_HOSTNAMES = ['amsterdam.sdox-test.de', 'baltimore.sdox-test.de', 'casablanca.sdox-test.de']
export const IS_STAGING = window?.location?.href.includes('.sdox-staging.de')

if ((IS_STAGING || IS_DEV || window?.location?.href.includes('debug=')) && !IS_TEST) {
  console.log('CONSTANTS', {
    HOSTNAME,
    DEV_HOSTNAMES,
    IS_DEV,
    IS_TEST,
    CI_COMMIT_SHA,
    CI_RELEASE_TAG_NAME,
    TEST_HOSTNAMES,
    IS_STAGING,
    TAB_UUID,
    APP_NAME,
    GQL_SCHEMA_HASH,
    SENTRY_ENABLED,
    MEMBER_ID,
  })
}
